import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TimeZoneService} from "../../../services/time-zone.service";
import {
  comparisonId as comparisonIdUtility
} from "../../../utils/comparison-function.util";
import {ReactiveFormsModule, UntypedFormControl} from "@angular/forms";
import {debounceTime, distinctUntilChanged, map, startWith, switchMap} from "rxjs/operators";
import {TimeZone} from "../../../modelinterfaces/time-zone.model";
import {BehaviorSubject, Observable, ReplaySubject} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {CommonModule} from "@angular/common";
import {MaterialModule} from "@common-module/material.module";

@Component({
  selector: 'app-select-timezone',
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MaterialModule,
    CommonModule
  ],
  templateUrl: './select-timezone.component.html',
  styleUrls: ['./select-timezone.component.scss']
})
export class SelectTimezoneComponent implements OnInit {

  @Input() timezone: TimeZone;
  @Input() disabled: boolean = false;
  @Output() timezoneChange = new EventEmitter<TimeZone>();

  comparisonId = comparisonIdUtility;
  control = new UntypedFormControl();
  $filteredTimeZones: Observable<TimeZone[]>;
  private searchTerms = new ReplaySubject<string>(1);
  private allTimeZones = new BehaviorSubject<TimeZone[]>([]);

  constructor(private timezoneService: TimeZoneService) {
  }

  ngOnInit(): void {
    this.control.setValue(this.timezone);
    if (this.disabled) {
      this.control.disable({emitEvent: false});
    }
    this.initFilter();
  }

  private initFilter() {
    this.$filteredTimeZones = this.searchTerms.pipe(
      startWith(''),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(term => this.filterTimeZones(term)),
    );
    this.timezoneService.getList().subscribe(timezones => {
      this.allTimeZones.next(timezones);
      this.searchTerms.next('');
    });
  }

  private filterTimeZones(term: string): Observable<TimeZone[]> {
    return this.allTimeZones.pipe(
      map(timezones => timezones.filter(timezone => timezone.description.toLowerCase().includes(term.toLowerCase())))
    );
  }

  public filterOptions(searchTerm: string): void {
    this.searchTerms.next(searchTerm);
  }

  public clearFilterOptions(): void {
    this.searchTerms.next('');
  }
}
